export const m = {
  EnterID: "กดคลิกเพื่อป้อนเข้า Tada ID",
  "select-specifications": "กดคลิกเพื่อเลือกสเปคที่ต้องการเติมเงิน",
  "check-account": "ตรวจสอบหมายเลขบัญชีที่ต้องการเติมเงิน",
  whatID: " Tada ID คืออะไร?",
  getID: "ป้อนเข้า Tada ID",
  maskgetID: "ป้อนเข้า Tada ID",
  "toastTips-format-error": "รูปแบบในการป้อนเข้าผิดพลาด",
  "toastTips-no-exist": "ไม่พบ ID นี้ในระบบ",
  toastTipsPlease: "กรุณาตรวจสอบหมายเลขบัญชีที่ต้องการเติมเงิน",
  "common-problem": "ปัญหาที่พบบ่อย",
  "transaction-succeeded": "ธุรกรรมสำเร็จ",
  "transaction-failed": "ธุรกรรมล้มเหลว",
  "transaction-cancel": "ยกเลิกธุรกรรม",
  "whether-account":
    "1.หลังจากที่ฉันเติมเงินเสร็จแล้ว ถ้าจะตรวจดูว่าเงินเข้าบัญชีหรือยังจะต้องทำอย่างไร?",
  "answer-whether-account":
    "หลังจากเติมเงินเสร็จสามารถกลับมาที่app (ของฉัน)-(กระเป๋าเงิน) เพื่อตรวจดูเพชร",
  "no-account": "2.หลังจากเติมเงินเสร็จแล้วถ้าเงินไม่เข้าบัญชีจะต้องทำอย่างไร?",
  "answer-no-account":
    "กรุณาเปิดappแล้วเข้าไปที่(ข่าวคราว)-(ข่าวคราวทางการ)-(ฟีดแบคและความช่วยเหลือ) รบกวนแจ้งปัญหาของท่านในนี้ และกรอกข้อความดังต่อไปนี้ด้วย ฝ่ายบริการลูกค้าของเราจะมอบความช่วยเหลือแก่ท่าน",
  "recharge-money": "1. ยอดเงินและ IDบัญชีที่ต้องการเติมเงิน",
  "recharge-time": "2.วันที่และเวลาที่เติมเงิน",
  "recharge-shot": "3.ภาพตัดหน้าจอที่ชำระเงินได้สำเร็จ",
  "recharge-wrong": "3.การเติมเงินผิดบัญชี การเติมยอดเงินผิดจะต้องทำอย่างไร",
  "answer-recharge-wrong":
    "กรุณาตรวจยืนยัน ID บัญชีและยอดเงินที่ต้องการเติมเงินอย่างละเอียดถี่ถ้วน ก่อนที่ท่านจะป้อนเข้ารหัสผ่านเพื่อชำระเงิน หากเติมยอดเงินผิดพลาดจะไม่สามารถนำเงินดังกล่าวคืนกลับมาได้ หากเติมเงินผิดบัญชีไป ท่านลองติดต่อกับ ID ที่ได้เติมเงินจริงนั้นดูก่อน ขอความกรุณาจากอีกฝ่ายว่าจะยินยอมชดเชยเงินดังกล่าวให้ท่านหรือไม่",
  refund: "4.คืนเงิน",
  "answer-refund":
    "ขออภัยค่ะ ปัจจุบันนี้Tadaไม่สนับสนุนการคืนเงินในรูปแบบใดทั้งสิ้น",
  "buy-enter-link":
    'การซื้อเพชรสามารถเติมเงินโดยผ่านลิงก์นี้ได้ <a class="web-link" href="https://pay.tadachat.info/">https://pay.tadachat.info</a> คัดลอกลิงก์นี้ไปวางไว้ที่เบราว์เซอร์ในมือถือเพื่อเปิดออก จากนั้นเข้าสู่หน้าเว็บการสั่งซื้อ หลังตรวจสอบหมายเลขบัญชีเสร็จแล้ว ให้เลือกสเปคที่สอดคล้องกันและเลือกใช้วิธีชำระเงินที่เหมาะสมเพื่อทำการชำระเงิน ซึ่งได้จัดส่วนลดไว้มากมาย! ',
  "buy-notice-a":
    "ระวัง:<a>pay.tadachat.info</a> เป็นเว็บไซต์ทางการหนึ่งเดียวที่ใช้ในการสั่งซื้อเพชร ",
  replace: "เปลี่ยนใหม่",
  sureBtn: "กำหนด",
  "pay-style": "เลือกวิธีการชำระเงิน",
  goBack: "กลับไปที่หน้าแรก",
  toastTips: "ป้อนเข้า Tada ID",
  rechargeFAQ_title: "ปัญหาที่พบบ่อย",
  PayStatusSuccess_title: "ธุรกรรมสำเร็จ",
  PayStatusFail_title: "ธุรกรรมล้มเหลว",
  PayStatusCancel_title: "ยกเลิกธุรกรรม",
  Diamonds_title: "เว็บไซต์เติมเพชรอย่างเป็นทางการของ Tada",
  "buy-notice":
    "โปรดทราบว่า  pay.Tadachat.info เป็นเว็บไซต์ซื้อเพชรอย่างเป็นทางการสำหรับ Tada เท่านั้นสำหรับการสอบถามการบริการลูกค้าโปรดไปที่ [ข้อความ] - [ข่าวอย่างเป็นทางการ] - [ข้อเสนอแนะและความช่วยเหลือ]",
  RechargeHelp_title: "ชาร์จความช่วยเหลือ",
  openAPP: "เปิดแอป Tada",
  "buy-diamonds-tit": "ซื้อบริการเพชร",
  description:
    "เว็บเพชรแบบชาร์จได้เพียงแห่งเดียวคือ Tada อย่างเป็นทางการ Tada เป็นแอปโซเชียลระดับสากลผู้ใช้อยู่ในกว่า 150 ประเทศและภูมิภาคทั่วโลกกําลังใช้ Tada อยู่",
  keywords:
    "ชาร์จ Tada, เติมเพชร Tada, อย่างเป็นทางการ Tada โหลด, เว็บไซต์อย่างเป็นทางการเติม Tada",
  "payforType": " วิธีการเติมเงิน",
  trueText: "กำหนด",
  falseText: "ยกเลิก",
  alertShowTxt1: "แน่ใจหรือว่าใช้",
  alertShowTxt3: " ในการเติมเพชร",
  alertShowTxt5: "",
  EnterIDTip: "เติมเงินด่วน Tada",
  scanLogin:
    "เพื่อความเป็นส่วนตัวและความปลอดภัยของบัญชีโปรดสแกนรหัสเพื่อเข้าสู่ระบบ",
  scanTip:
    'เคล็ดลับ: คลิก "สแกน" ที่มุมขวาบนของ Tada "ศูนย์ส่วนบุคคล / พลวัต" เพื่อสแกนรหัสเพื่อเข้าสู่ระบบในขณะเดียวกันก็รองรับการเข้าสู่ระบบโดยระบุภาพหน้าจอรหัส QR',
  scanVersion: "โปรดอัปเกรด Tada เป็นเวอร์ชัน %s และสแกนรหัสเพื่อเข้าสู่ระบบ",
  delAccount: "การลบบัญชี",
  logout: "เลิกทำ",
  submit: "เสนอ",
  email_place_holder: "ใส่อีเมลของคุณ",
  contact_email: "อีเมลติดต่อ",
  provide_email: "โปรดระบุที่อยู่อีเมลของคุณเพื่อรับการแจ้งการชำระเงิน",
  email_address: "ที่อยู่อีเมล",
  reseller: "ตัวแทนจำหน่าย",
};



// WEBPACK FOOTER //
// ./src/lang/th.js